import React, { memo } from 'react';
import TableCell from './TableCell';

export function TableFastCell({ cell, row, index }: any) {
  return <TableCell cell={cell} row={row} index={index} />;
}

export default memo(TableFastCell, (prevProps: any, nextProps: any) => {
  if (
    prevProps.row.canExpand === nextProps.row.canExpand &&
    prevProps.row.isExpanded === nextProps.row.isExpanded &&
    prevProps.cell.value === nextProps.cell.value &&
    prevProps.cell.maxWidth === nextProps.cell.maxWidth &&
    prevProps.cell.width === nextProps.cell.width
  ) {
    return true;
  } else {
    return false;
  }
});
